import React, { memo } from 'react'
import { string } from 'prop-types'

export const Close = memo(({ width = '26px', color = '#757575', height = '26px' }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 26 26"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<title>close</title>
			<desc>Created with Sketch.</desc>
			<g id="Re-Branded-Designs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g id="LogIn---Comp-1b-Copy" transform="translate(-552.000000, -22.000000)">
					<g id="Header">
						<g id="close" transform="translate(548.000000, 18.000000)">
							<g id="Frame_-_24px">
								<rect id="Rectangle" x="0" y="0" width="34" height="34"></rect>
							</g>
							<g
								id="Line_Icons"
								transform="translate(4.000000, 4.000000)"
								fill={color}
								fillRule="nonzero"
							>
								<polygon
									id="Path"
									points="25.6374444 2.46566667 23.5935556 0.423222222 13.0606667 10.9575556 2.52633333 0.423222222 0.482444444 2.46566667 11.0167778 13 0.482444444 23.5343333 2.52633333 25.5767778 13.0606667 15.0424444 23.5935556 25.5767778 25.6374444 23.5343333 15.1031111 13"
								></polygon>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
	)
})
Close.propTypes = {
	width: string,
	color: string,
	height: string,
}
